import { SchoolContact } from "./school-contact";

export class BookingImmersionInfo {
    public id?: number;
    
    constructor(
        public programmeName: string,
        public programmeDetail: string,
        public localCoordinatorName: string,
        public localCoordinatorPhone: string,
        public localCoordinatorSecondPhone: string,
        public localCoordinatorEmail: string,
        public activityCenterName: string, 
        public activityCenterAddress: string,
        public activityCenterEmail: string,
        public activityCenterPhone: string,
        public schoolContactList: SchoolContact[] 
    ){}
}
